// lib
import { useContext, useState, useMemo, useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { DataContext } from '@aytm/app/stats/page/sidebar/filters/FiltersPanel'

// components
import { RadioButton } from 'primereact/radiobutton'

// styles
import style from '@aytm/app/stats/page/sidebar/filters/styles/FiltersPanel.module.scss'

const FiltersRowCompletes = ({ filter, filterValues, filterOptions }) => {
  const { features, onParamsChange } = useContext(DataContext)

  const [values, setValues] = useState(null !== filterValues ? JSON.parse(filterValues) : filterValues)
  const [options, setOptions] = useState(filterOptions)

  const filterDisabled = useMemo(
    () => features.filters.disabled || filter.disabled,
    [features.filters.disabled, filter.disabled]
  )

  const onFilterChange = useCallback(
    event => {
      setValues(event.value)
      onParamsChange({
        [filter.key]: ('completes' != event.value && event.value) || null
      })
    },
    [filter, onParamsChange]
  )

  useEffect(() => {
    const _values = null !== filterValues ? JSON.parse(filterValues) : filterValues
    setValues(_values)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValues])

  useEffect(() => setOptions(filterOptions), [filterOptions])

  return (
    <div
      data-id={filter.key}
      data-testid={`stat-filters-row-${filter.key}`}
      className={`${style['filter-row']} ${style[`offset-${filter.lvl || 0}`]}`}
    >
      {options.map(option => (
        <div
          key={`${filter.key}-${option.value}`}
          data-testid={`stat-filters-row-${filter.key}-${option.value}`}
          className={style['filter-radio']}
        >
          <RadioButton
            aria-labelledby={`stat-filters-row-${filter.key}-${option.value}-label`}
            value={option.value}
            checked={values == option.value}
            disabled={filterDisabled}
            onChange={filterDisabled ? null : onFilterChange}
          />
          <span
            id={`stat-filters-row-${filter.key}-${option.value}-label`}
            className={classNames(style['row-label'], { 'p-disabled': filterDisabled })}
            onClick={filterDisabled ? null : onFilterChange.bind(this, option)}
            dangerouslySetInnerHTML={{ __html: option.label }}
          />
        </div>
      ))}
    </div>
  )
}

FiltersRowCompletes.propTypes = {
  filter: PropTypes.object,
  filterValues: PropTypes.any,
  filterOptions: PropTypes.any
}

FiltersRowCompletes.displayName = 'FiltersRowCompletes'

export default FiltersRowCompletes
